import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { SERVER_URL } from '../../util/EnvironmentConfig';
import axios from 'axios';
import Modal from '@mui/material/Modal';

const token = localStorage.getItem('loginToken');
const userData = token ? jwtDecode(token) : '';

const placeholder = {
  id: 0,
  name: 'Default',
  category: 'Default',
  points: 10,
  image:
    'https://badergruppe.com/wp-content/uploads/2021/11/placeholder-800x800.png',
  description: 'Default',
  terms: 'Default',
  delivery: 'Default',
  dateAvailable: '0000-00-00T23',
  validity: '2099-12-31-T23',
};

const Marketplace = () => {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(placeholder);
  const [userPoints, setUserPoints] = useState(0);
  const [prodPopUp, setProdPopUp] = useState(false);
  const [redPopUp, setRedPopUp] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
    fetchUserPoints();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.post(`${SERVER_URL}/reward/get-rewards`, {
        userId: userData.id,
      });
      setProducts(
        response.data.products.map((item) => ({
          id: item._id,
          name: item.rewardName,
          category: item.category,
          points: item.pointsRequired,
          image: item.rewardImages,
          description: item.rewardDescription,
          terms: item.rewardTerms,
          delivery: item.methodOfDelivery,
          validity: item.validity,
        })),
      );
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserPoints = async () => {
    try {
      const response = await axios.post(`${SERVER_URL}/user/points-balance`, {
        userId: userData.id,
      });
      setUserPoints(response.data.points);
    } catch (error) {
      console.error('Error fetching user points:', error);
    }
  };

  const handleItemClick = (product) => {
    setSelectedProduct(product);
    setProdPopUp(true);
  };

  const redeemOffer = async () => {
    try {
      await axios.post(`${SERVER_URL}/user/update-points-balance`, {
        userId: userData.id,
        points: -selectedProduct.points,
        activity: `Redeemed ${selectedProduct.name}`,
      });
      fetchUserPoints();
      setProdPopUp(false);
      setRedPopUp(true);
      setTimeout(() => setRedPopUp(false), 2000);
    } catch (error) {
      console.error('Error redeeming product:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-white">Redeem Points</h1>
          <div className="bg-purple-600 px-4 py-2 rounded-full text-white font-semibold">
            {userPoints} Points
          </div>
        </div>
        {loading ? (
          <div className="text-white text-center">Loading...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <div
                key={product.id}
                className="bg-gray-800 p-4 rounded-lg shadow-lg hover:scale-105 transition"
                onClick={() => handleItemClick(product)}
              >
                <img
                  src={product.image}
                  className="w-full h-40 object-cover rounded-md"
                />
                <div className="mt-3">
                  <h3 className="text-lg font-semibold text-white">
                    {product.name}
                  </h3>
                  <p className="text-sm text-gray-400">{product.category}</p>
                  <div className="mt-2 bg-purple-500 px-3 py-1 text-white rounded-full w-max">
                    {product.points} Points
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Product Modal */}
      <Modal open={prodPopUp}>
        <div
          className="fixed inset-0 flex justify-center items-center p-3"
          onClose={() => setProdPopUp(false)}
        >
          <div className="bg-gray-800 p-6 rounded-lg max-w-lg w-full text-white relative">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">{selectedProduct.name}</h2>
              <button
                className="text-gray-400 hover:text-white"
                onClick={() => setProdPopUp(false)}
              >
                X
              </button>
            </div>
            <p className="text-gray-400">{selectedProduct.category}</p>
            <img
              src={selectedProduct.image}
              className="w-full h-48 object-cover rounded-md mt-3"
            />
            <p className="mt-3">{selectedProduct.description}</p>
            <p className="text-sm mt-2 text-gray-400">
              {selectedProduct.terms}
            </p>
            <div className="mt-4 flex justify-between items-center">
              <span className="text-lg font-bold">
                {selectedProduct.points} Points
              </span>
              <button
                className="bg-orange-500 px-4 py-2 rounded-lg text-white font-semibold disabled:bg-gray-600"
                onClick={redeemOffer}
                disabled={selectedProduct.points > userPoints}
              >
                Redeem
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Redeemed Notification */}
      <Modal open={redPopUp}>
        <div className="fixed bottom-5 right-5 bg-green-500 text-white px-4 py-2 rounded-md shadow-lg">
          Redeemed {selectedProduct.name}! 🎉
        </div>
      </Modal>
    </div>
  );
};

export default Marketplace;
